"use strict";
const form = document.getElementById("contactForm");
const sendBtn = document.getElementById("sendBtn");
const formMessage = document.getElementById("formMessage");
const FORM_ENDPOINT = "https://script.google.com/macros/s/AKfycbw2QrQvKWDXjSKg0xD1NQV2Y8HCzsvAFFvRdwSfWNYCVM24ZNa7Ev18Tt5SCSaXHadQng/exec";
let isSubmitting = false;
let lastSubmitTime = 0;
const MIN_SUBMIT_INTERVAL = 10000; // 10 seconds
form.addEventListener("submit", async function(event) {
    event.preventDefault();
    if (isSubmitting) return;
    const now = Date.now();
    if (now - lastSubmitTime < MIN_SUBMIT_INTERVAL) {
        showMessage("Please wait a few seconds before submitting again.", "error");
        return;
    }
    /* Honeypot bot detection */ const honeypot = form.elements["website"];
    if (honeypot && honeypot.value.trim() !== "") {
        showMessage("Unable to process your request.", "error");
        return;
    }
    /* Browser validation */ if (!form.checkValidity()) {
        form.reportValidity();
        return;
    }
    /* Collect data */ const formData = new FormData(form);
    const data = {
        firstName: formData.get("firstName")?.trim(),
        lastName: formData.get("lastName")?.trim(),
        email: formData.get("email")?.trim(),
        organization: formData.get("organization")?.trim(),
        phone: formData.get("phone")?.trim(),
        message: formData.get("message")?.trim()
    };
    /* Basic length protection */ if (data.firstName.length > 50 || data.lastName.length > 50 || data.email.length > 100 || data.organization.length > 100 || data.phone.length > 20 || data.message.length > 500) {
        showMessage("Please enter valid information.", "error");
        return;
    }
    isSubmitting = true;
    sendBtn.disabled = true;
    sendBtn.textContent = "Sending...";
    try {
        const response = await fetch(FORM_ENDPOINT, {
            method: "POST",
            body: JSON.stringify(data)
        });
        if (!response.ok) throw new Error("Request failed");
        form.reset();
        lastSubmitTime = Date.now();
        showMessage("Thank you! Your request has been sent successfully.", "success");
    } catch (error) {
        console.error(error);
        showMessage("Something went wrong. Please try again later.", "error");
    } finally{
        isSubmitting = false;
        sendBtn.disabled = false;
        sendBtn.textContent = "Send it \u2192";
    }
});
function showMessage(message, type) {
    formMessage.textContent = message;
    formMessage.style.color = type === "success" ? "#00f5ff" : "#ff6b6b";
}
(()=>{
    const button = document.getElementById("whatsapp-float");
    let isDragging = false;
    let hasMoved = false;
    let startX = 0;
    let startY = 0;
    let offsetX = 0;
    let offsetY = 0;
    button.addEventListener("pointerdown", (event)=>{
        event.preventDefault();
        const rect = button.getBoundingClientRect();
        startX = event.clientX;
        startY = event.clientY;
        offsetX = event.clientX - rect.left;
        offsetY = event.clientY - rect.top;
        isDragging = true;
        hasMoved = false;
        button.classList.add("dragging");
        button.setPointerCapture(event.pointerId);
    });
    button.addEventListener("pointermove", (event)=>{
        if (!isDragging) return;
        const distance = Math.hypot(event.clientX - startX, event.clientY - startY);
        if (distance > 5) hasMoved = true;
        if (!hasMoved) return;
        const maxX = window.innerWidth - button.offsetWidth;
        const maxY = window.innerHeight - button.offsetHeight;
        const newX = Math.max(0, Math.min(maxX, event.clientX - offsetX));
        const newY = Math.max(0, Math.min(maxY, event.clientY - offsetY));
        button.style.left = `${newX}px`;
        button.style.top = `${newY}px`;
        button.style.right = "auto";
        button.style.bottom = "auto";
    });
    button.addEventListener("pointerup", (event)=>{
        if (!isDragging) return;
        isDragging = false;
        button.classList.remove("dragging");
        if (button.hasPointerCapture(event.pointerId)) button.releasePointerCapture(event.pointerId);
        if (hasMoved) {
            // Drag করার পর যেন WhatsApp ওপেন না হয়
            button.dataset.preventClick = "true";
            setTimeout(()=>{
                button.dataset.preventClick = "false";
            }, 100);
        }
    });
    button.addEventListener("click", (event)=>{
        if (button.dataset.preventClick === "true") event.preventDefault();
    });
    window.addEventListener("resize", ()=>{
        if (!button.style.left) return;
        const rect = button.getBoundingClientRect();
        button.style.left = Math.min(rect.left, window.innerWidth - button.offsetWidth) + "px";
        button.style.top = Math.min(rect.top, window.innerHeight - button.offsetHeight) + "px";
    });
})();

//# sourceMappingURL=cube-code-src.24e0dc51.js.map
